import moment from 'moment';

export const getBirthDateFromAge = (age) => {
  if (age === undefined) return null;
  const birthAge = moment().startOf('day').add(age * -1, 'Y');
  return moment.utc(birthAge, 'DD/MM/YYYY').toDate();
};


// WEBPACK FOOTER //
// ./src/utils/dateFactory.js